export default "/bundles/assets/attachment_xls_d8b8f46cf43668ce4ed92b4a65bf3ed0.png";